// @ts-nocheck
import React from 'react';

const SvgChart = props => (
  <svg viewBox="0 0 64 64" {...props}>
    <path
      d="M54.02 52.02h-44a2 2 0 0 1 0-4h44a2 2 0 1 1 0 4zm-2-6h-8a2 2 0 0 1-2-2v-22a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v22a2 2 0 0 1-2 2zm-16-34a2 2 0 0 1 2 2v30a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-30a2 2 0 0 1 2-2zm-16 16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2z"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgChart;
